module.exports = __webpack_public_path__ + "img/annotation-plus.9b41d873.svg";